export default __webpack_public_path__ + "static/media/pc.937c577e.png";